import React, { useState, useEffect, useContext, useRef } from "react";

import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";

import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Autocomplete, {
createFilterOptions,
} from "@material-ui/lab/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import ButtonWithSpinner from "../ButtonWithSpinner";
import ContactModal from "../ContactModal";
import ConnectionSelectDialog from "../ConnectionSelectDialog";
import toastError from "../../errors/toastError";
import { makeStyles } from "@material-ui/core/styles";
import { AuthContext } from "../../context/Auth/AuthContext";
import { SettingsContext } from "../../context/Settings/SettingsContext";
import { visibleWhatsappsForUser } from "../../helpers/canAccessTicket";
import {  WhatsApp } from "@material-ui/icons";
import { Grid, ListItemText, MenuItem, Select, DialogContentText, Box, FormControl, InputLabel } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import { toast } from "react-toastify";
import { extractVariables } from "../../utils/templateValidator";
//import ShowTicketOpen from "../ShowTicketOpenModal";

const useStyles = makeStyles((theme) => ({
  online: {
    fontSize: 11,
    color: "#25d366"
  },
  offline: {
    fontSize: 11,
    color: "#e1306c"
  },
  dialogInputs: {
    "& .MuiInputBase-input": {
      color: theme.palette.text.primary,
    },
    "& .MuiInputLabel-root": {
      color: theme.palette.text.secondary,
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.3)" : "rgba(0,0,0,0.23)",
    },
    "& .MuiSelect-icon": {
      color: theme.palette.text.primary,
    },
    "& .MuiSelect-root": {
      color: theme.palette.text.primary,
    },
    "& .MuiAutocomplete-clearIndicator": {
      color: theme.palette.text.secondary,
    },
    "& .MuiAutocomplete-popupIndicator": {
      color: theme.palette.text.secondary,
    },
  },
}));

const filter = createFilterOptions({
  trim: true,
});

const isConnectedStatus = (status) => String(status || "").toUpperCase() === "CONNECTED";

const NewTicketModal = ({ modalOpen, onClose, initialContact, initialWhatsappId }) => {
  const classes = useStyles();
  const [options, setOptions] = useState([]);

  const [loading, setLoading] = useState(false);
  const [searchParam, setSearchParam] = useState("");
  const [selectedContact, setSelectedContact] = useState(null);
  const [selectedQueue, setSelectedQueue] = useState("");
  const [selectedWhatsapp, setSelectedWhatsapp] = useState("");
  const [newContact, setNewContact] = useState({});
  const [whatsapps, setWhatsapps] = useState([]);
  const [contactModalOpen, setContactModalOpen] = useState(false);
  const { user } = useContext(AuthContext);
  const userHasQueues = (user?.queues?.length || 0) > 0;
  const { connectionScopeEnabled } = useContext(SettingsContext);
  const { companyId, whatsappId } = user;

  const [ openAlert, setOpenAlert ] = useState(false);
const [ userTicketOpen, setUserTicketOpen] = useState("");
const [ queueTicketOpen, setQueueTicketOpen] = useState("");
  const [ existingTicket, setExistingTicket ] = useState(null);
  const [ pendingContactId, setPendingContactId ] = useState(null);

  // Popup em grade para escolher a conexão do novo chamado
  const [connectionDialogOpen, setConnectionDialogOpen] = useState(false);
  const connectionPromptShownRef = useRef(false);

  // Cloud API - template picker state
  const [templatePickerOpen, setTemplatePickerOpen] = useState(false);
  const [cloudApiTemplates, setCloudApiTemplates] = useState([]);
  const [selectedCloudApiTemplate, setSelectedCloudApiTemplate] = useState("");
  const [cloudApiTemplateVars, setCloudApiTemplateVars] = useState([]);
  const [sendingTemplate, setSendingTemplate] = useState(false);
  const [loadingTemplates, setLoadingTemplates] = useState(false);
  const [createdTicket, setCreatedTicket] = useState(null);

  const findWhatsappById = (list, id) => {
    if (id === undefined || id === null || id === "") return undefined;
    return (list || []).find((w) => Number(w.id) === Number(id));
  };

  const getTemplateVariables = (template) => {
    const ordered = [];
    const addVars = (text) => {
      extractVariables(text || "").forEach((v) => {
        if (!ordered.includes(v)) {
          ordered.push(v);
        }
      });
    };

    if (template?.components?.length) {
      template.components.forEach((comp) => {
        const compType = String(comp.type || "").toUpperCase();
        const compFormat = String(comp.format || "").toUpperCase();
        if (compType === "BODY") {
          addVars(comp.text || template.bodyText || "");
        }
        if (compType === "HEADER" && compFormat === "TEXT") {
          addVars(comp.text || "");
        }
        if ((compType === "BUTTONS" || compType === "BUTTON") && Array.isArray(comp.buttons)) {
          comp.buttons.forEach((btn) => {
            const btnType = String(btn.type || "").toUpperCase();
            if (btnType === "URL") {
              addVars(btn.url || "");
            }
          });
        }
      });
    } else {
      addVars(template?.bodyText || "");
    }

    return ordered;
  };

  useEffect(() => {
    if (initialContact?.id !== undefined) {
      setOptions([initialContact]);
      setSelectedContact(initialContact);
    }
  }, [initialContact]);

  useEffect(() => {
    if (!modalOpen) {
      return;
    }

    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchWhatsapps = async () => {
        try {
          const { data: allWhatsapps } = await api.get(`/whatsapp`, { params: { companyId, session: 0 } });
          const data = visibleWhatsappsForUser(user, allWhatsapps, connectionScopeEnabled);
          setWhatsapps(data);
          
          // Buscar configuração de Auto Gerenciamento de Conexão
          const settingsRes = await api.get(`/settings`);
          const autoManageSetting = settingsRes.data.find(s => s.key === "autoManageConnection");
          const autoManageEnabled = autoManageSetting?.value === "enabled";
          // Um por conexão (unifyTicketsByContact=disabled): sem escolha, o
          // chamado nasce na conexão do atendente, como no auto gerenciamento.
          const perConnection = settingsRes.data.find(s => s.key === "unifyTicketsByContact")?.value === "disabled";
          
          console.log(`[NewTicketModal] autoManageEnabled=${autoManageEnabled}, user.whatsappId=${user.whatsappId}, typeof=${typeof user.whatsappId}`);
          
          // Lógica de seleção automática de conexão
          if (data && data.length > 0) {
            let selectedConnection = null;

            // AUTO GERENCIAMENTO HABILITADO: Priorizar conexão do usuário
            if ((autoManageEnabled || perConnection) && user.whatsappId) {
              console.log(`[NewTicketModal] Looking for user whatsapp id=${user.whatsappId}`);
              const userWhatsapp = findWhatsappById(data, user.whatsappId);
              console.log(`[NewTicketModal] Found userWhatsapp=${!!userWhatsapp}, id=${userWhatsapp?.id}, status=${userWhatsapp?.status}`);
              if (userWhatsapp && isConnectedStatus(userWhatsapp.status)) {
                selectedConnection = userWhatsapp;
                console.log(`[NewTicketModal] Selected user whatsapp: ${selectedConnection.id} - ${selectedConnection.name}`);
              }
            }

            // Se não encontrou conexão do usuário ou auto gerenciamento está DESABILITADO
            // usar conexão padrão da empresa
            if (!selectedConnection) {
              // Filtrar conexões ativas (CONNECTED)
              const connectedWhatsapps = data.filter((w) => isConnectedStatus(w.status));
              
              if (connectedWhatsapps.length > 0) {
                // Priorizar a conexão padrão se estiver conectada
                const defaultConnected = connectedWhatsapps.find(w => w.isDefault);
                if (defaultConnected) {
                  selectedConnection = defaultConnected;
                } else {
                  // Usar a primeira conectada
                  selectedConnection = connectedWhatsapps[0];
                }
              } else {
                // Se nenhuma está conectada, priorizar a padrão
                const defaultWhatsapp = data.find(w => w.isDefault);
                if (defaultWhatsapp) {
                  selectedConnection = defaultWhatsapp;
                } else {
                  // Usar a primeira disponível
                  selectedConnection = data[0];
                }
              }
            }

            if (selectedConnection) {
              setSelectedWhatsapp(selectedConnection.id);
            }
          }
        } catch (err) {
          toastError(err);
        }
      };

      // Só definir fila padrão se usuário tiver apenas uma
      if (user.queues.length === 1) {
        setSelectedQueue(user.queues[0].id);
      }
      
      fetchWhatsapps();
      setLoading(false);
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [modalOpen, companyId, user.queues?.length, user.whatsappId, connectionScopeEnabled])

  // Se receber initialWhatsappId (ex: da aba de contatos), pré-seleciona a conexão
  useEffect(() => {
    if (initialWhatsappId && whatsapps.length > 0) {
      const found = findWhatsappById(whatsapps, initialWhatsappId);
      if (found) {
        setSelectedWhatsapp(found.id);
      }
    }
  }, [initialWhatsappId, whatsapps]);

  // Obrigatório: ao abrir um novo chamado com mais de uma conexão ativa,
  // abre o popup em grade para o usuário escolher qual conexão usar.
  // Se a conexão veio pré-escolhida (initialWhatsappId), respeita a escolha.
  useEffect(() => {
    if (!modalOpen) {
      connectionPromptShownRef.current = false;
      setConnectionDialogOpen(false);
      return;
    }
    if (connectionPromptShownRef.current) return;
    if (initialWhatsappId) return;

    const connectedWhatsapps = (whatsapps || []).filter(w => isConnectedStatus(w.status));
    if (connectedWhatsapps.length > 1) {
      connectionPromptShownRef.current = true;
      setConnectionDialogOpen(true);
    }
  }, [modalOpen, whatsapps, initialWhatsappId]);

  useEffect(() => {
    if (!modalOpen || searchParam.length < 3) {
      setLoading(false);
      return;
    }
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchContacts = async () => {
        try {
          const { data } = await api.get("contacts", {
            // searchScope: busca só no cadastro do contato, sem varrer o corpo
            // das mensagens (que traria quem apenas citou a palavra).
            params: { searchParam, searchScope: "contact" },
          });
          setOptions(data.contacts);
          setLoading(false);
        } catch (err) {
          setLoading(false);
          toastError(err);
        }
      };
      fetchContacts();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchParam, modalOpen]);

  const handleClose = () => {
    onClose();
    setSearchParam("");
    setOpenAlert(false);
    setUserTicketOpen("");
    setQueueTicketOpen("");
    setExistingTicket(null);
    setPendingContactId(null);
    setSelectedContact(null);
    setTemplatePickerOpen(false);
    setCreatedTicket(null);
    setSelectedCloudApiTemplate("");
    setCloudApiTemplateVars([]);
    // Sem isto a fila escolhida vazava para o próximo chamado aberto pelo modal.
    setSelectedQueue("");
  };

  const handleCloseAlert = () => {
    setOpenAlert(false);
    setUserTicketOpen("");
    setQueueTicketOpen("");
    setExistingTicket(null);
    setPendingContactId(null);
  };

  const handleOpenExistingTicket = () => {
    if (existingTicket && existingTicket.uuid) {
      setOpenAlert(false);
      handleClose();
      onClose(existingTicket);
    }
  };

  // Usuário confirmou no popup: criar novo ticket na conexão selecionada mesmo
  // havendo ticket aberto em outra conexão
  const handleForceCreateTicket = () => {
    const contactId = pendingContactId || selectedContact?.id;
    setOpenAlert(false);
    setUserTicketOpen("");
    setQueueTicketOpen("");
    setExistingTicket(null);
    if (contactId) {
      handleSaveTicket(contactId, { force: true });
    }
  };

  // Só oferece "criar novo" se o ticket existente estiver em OUTRA conexão —
  // na mesma conexão o backend continua bloqueando duplicados
  // Grupo tem um único chamado (em qualquer conexão): nunca oferece "criar
  // novo" — o backend reaproveita/move o existente e o `force` voltaria ao
  // mesmo erro em loop.
  const existingIsGroup = Boolean(existingTicket?.groupSingleTicket);
  const canForceNewTicket =
    !existingIsGroup &&
    (!existingTicket?.whatsapp?.id ||
      Number(existingTicket.whatsapp.id) !== Number(selectedWhatsapp));

  // === Cloud API Template Picker Handlers ===
  const handleOpenTemplatePicker = async (whatsappObj, ticket) => {
    setCreatedTicket(ticket);
    setLoadingTemplates(true);
    setTemplatePickerOpen(true);
    try {
      // Usar wabaId para carregar templates compartilhados entre números da mesma conta
      const queryParams = whatsappObj.cloudApiBusinessAccountId
        ? { wabaId: whatsappObj.cloudApiBusinessAccountId }
        : { whatsappId: whatsappObj.id };
      const { data } = await api.get("/message-templates", {
        params: queryParams,
      });
      setCloudApiTemplates(
        (data.templates || data).filter((t) => t.status === "APPROVED")
      );
    } catch (err) {
      toastError(err);
    } finally {
      setLoadingTemplates(false);
    }
  };

  const handleSelectCloudApiTemplate = (templateId) => {
    setSelectedCloudApiTemplate(templateId);
    const template = cloudApiTemplates.find((t) => t.id === parseInt(templateId));
    if (template) {
      const varsList = getTemplateVariables(template);
      const vars = varsList.map((v) => ({ name: v, value: "" }));
      setCloudApiTemplateVars(vars);
    } else {
      setCloudApiTemplateVars([]);
    }
  };

  const handleSendCloudApiTemplate = async () => {
    if (!selectedCloudApiTemplate || !createdTicket) return;
    setSendingTemplate(true);
    try {
      let variables = undefined;
      if (cloudApiTemplateVars.length > 0) {
        variables = cloudApiTemplateVars.map((v) => v.value || "");
      }
      await api.post(`/message-templates/${selectedCloudApiTemplate}/send`, {
        ticketId: createdTicket.id,
        variables,
      });
      toast.success(i18n.t("newTicketModal.templatePicker.sent"));
      setTemplatePickerOpen(false);
      setSelectedCloudApiTemplate("");
      setCloudApiTemplateVars([]);
      onClose(createdTicket);
      setCreatedTicket(null);
    } catch (err) {
      toastError(err);
    } finally {
      setSendingTemplate(false);
    }
  };

  const handleCloseTemplatePicker = () => {
    setTemplatePickerOpen(false);
    setSelectedCloudApiTemplate("");
    setCloudApiTemplateVars([]);
    // Ticket was already created, navigate to it
    if (createdTicket) {
      onClose(createdTicket);
      setCreatedTicket(null);
    }
  };

  const handleSaveTicket = async (contactId, { force = false } = {}) => {
    if (!contactId) return;

    // Validate WhatsApp connection
    if (selectedWhatsapp === "") {
      toast.error(i18n.t("newTicketModal.errors.selectConnection"));
      return;
    }

    // Quem tem fila precisa dizer em qual o chamado nasce (com uma só, ela já
    // vem selecionada). Sem fila nenhuma, segue a regra da conexão no backend.
    if (userHasQueues && selectedQueue === "") {
      toast.error(i18n.t("newTicketModal.selectQueue"));
      return;
    }

    // Autor: GitHub Copilot | Data: 26/03/2026 | Motivo: evitar falha de validação quando id vem como string.
    const selectedWhatsappObj = findWhatsappById(whatsapps, selectedWhatsapp);
    if (selectedWhatsappObj && !isConnectedStatus(selectedWhatsappObj.status)) {
      toast.error(i18n.t("newTicketModal.errors.connectionNotConnected"));
      return;
    }
    
    setLoading(true);
    try {
      const queueId = selectedQueue !== "" ? selectedQueue : null;
      const whatsappId = selectedWhatsapp !== "" ? selectedWhatsapp : null;

      console.log("[NewTicketModal] handleSaveTicket -> POST /tickets", {
        contactId,
        queueId,
        whatsappId,
        userId: user?.id,
        force,
        selectedWhatsappType: selectedWhatsappObj?.type,
        selectedWhatsappStatus: selectedWhatsappObj?.status,
      });

      const { data: ticket } = await api.post("/tickets", {
        contactId: contactId,
        queueId,
        whatsappId,
        userId: user.id,
        status: "open",
        force,
      });

      console.log("[NewTicketModal] POST /tickets response", {
        ticket: ticket
          ? {
              id: ticket.id,
              uuid: ticket.uuid,
              status: ticket.status,
              whatsappId: ticket.whatsappId,
              contactId: ticket.contactId,
              userId: ticket.userId,
            }
          : ticket,
      });

      // Cloud API: new tickets have no 24h window - show template picker
      if (selectedWhatsappObj && selectedWhatsappObj.type === 'cloudapi') {
        // DEBUG: log what backend thinks about the 24h window for this contact+whatsapp
        try {
          const { data: windowInfo } = await api.get("/cloudapi/window-by-contact", {
            params: { contactId, whatsappId: selectedWhatsappObj.id },
          });
          console.log("[NewTicketModal] GET /cloudapi/window-by-contact response", windowInfo);

          if (windowInfo?.requiresTemplate) {
            setLoading(false);
            handleOpenTemplatePicker(selectedWhatsappObj, ticket);
            return;
          }
        } catch (err) {
          console.error("[NewTicketModal] GET /cloudapi/window-by-contact failed", err);
          // Fallback: mantém comportamento atual (abrir template picker) para não bloquear criação
          setLoading(false);
          handleOpenTemplatePicker(selectedWhatsappObj, ticket);
          return;
        }
      }

      onClose(ticket);
    } catch (err) {
      // Verificar se é o erro de ticket já aberto
      if (err.response?.data?.error === "ERR_OTHER_OPEN_TICKET") {
        setLoading(false);
        
        // Tentar parsear os dados do ticket existente da mensagem de erro
        let ticketData = null;
        try {
          // O backend agora pode retornar os dados em err.response.data.details
          if (err.response.data.details) {
            ticketData = typeof err.response.data.details === 'string' 
              ? JSON.parse(err.response.data.details) 
              : err.response.data.details;
          }
        } catch (parseError) {
          console.error("Erro ao parsear dados do ticket:", parseError);
        }

        if (ticketData) {
          setExistingTicket(ticketData);
          setPendingContactId(contactId);
          setUserTicketOpen(ticketData.user?.name || i18n.t("newTicketModal.existingTicket.unknownUser"));
          setQueueTicketOpen(ticketData.queue?.name || i18n.t("newTicketModal.noQueue"));
          setOpenAlert(true);
        } else {
          // Se não conseguir parsear, apenas mostrar mensagem genérica
          toast.error(i18n.t("newTicketModal.existingTicket.message"));
        }
        return;
      }

      // Tentar o método antigo de parse (retrocompatibilidade)
      try {
        const ticket = JSON.parse(err.response.data.error);

        if (ticket.userId !== user?.id) {
          setExistingTicket(ticket);
          setPendingContactId(contactId);
          setOpenAlert(true);
          setUserTicketOpen(ticket.user.name);
          setQueueTicketOpen(ticket.queue.name);
        } else {
          setOpenAlert(false);
          setUserTicketOpen("");
          setQueueTicketOpen("");
          setLoading(false);
          onClose(ticket);
        }
      } catch (parseError) {
        // Se parsing falhar, tratar como erro regular
        setLoading(false);
        toastError(err);
      }
    }  
    setLoading(false);
  };

  const handleSelectOption = (e, newValue) => {
    // Contato existente tem id (inclui contatos sem número, ex.: Instagram @handle)
    if (newValue?.id || newValue?.number) {
      setSelectedContact(newValue);
    } else if (newValue?.name) {
      setNewContact({ name: newValue.name });
      setContactModalOpen(true);
    }
  };

  const handleCloseContactModal = () => {
    setContactModalOpen(false);    
  };

  const handleAddNewContactTicket = contact => {
    // Fica selecionado: se faltar a fila, o atendente escolhe e salva de novo.
    setSelectedContact(contact);
    handleSaveTicket(contact.id);
  };

  const createAddContactOption = (filterOptions, params) => {
    const filtered = filter(filterOptions, params);
    if (params.inputValue !== "" && !loading && searchParam.length >= 3) {
      filtered.push({
        name: `${params.inputValue}`,
      });
    }
    return filtered;
  };

  const contactHandle = option =>
    option.number || (option.instagramUsername ? `@${option.instagramUsername}` : "");

  const renderOption = option => {
    if (option.id || option.number) {
      const handle = contactHandle(option);
      return <>
        <Typography component="span" style={{ fontSize: 14, marginLeft: "10px", display: "inline-flex", alignItems: "center", lineHeight: "2" }}>
          {handle ? `${option.name} - ${handle}` : option.name}
        </Typography>
      </>
    } else {
      return `${i18n.t("newTicketModal.add")} ${option.name}`;
    }
  };

  const renderOptionLabel = option => {
    if (option.id || option.number) {
      const handle = contactHandle(option);
      return handle ? `${option.name} - ${handle}` : `${option.name}`;
    } else {
      return `${option.name}`;
    }
  };

  const renderContactAutocomplete = () => {
    if (!initialContact || initialContact.id === undefined) {
      return (
        <Grid xs={12} item>
          <Autocomplete
            fullWidth
            options={options}
            loading={loading}
            clearOnBlur
            autoHighlight
            freeSolo
            clearOnEscape
            getOptionLabel={renderOptionLabel}
            renderOption={renderOption}
            filterOptions={createAddContactOption}
            onChange={(e, newValue) => handleSelectOption(e, newValue)}
            renderInput={params => (
              <TextField
                {...params}
                label={i18n.t("newTicketModal.fieldLabel")}
                variant="outlined"
                autoFocus
                onChange={e => setSearchParam(e.target.value)}
                onKeyPress={e => {
                  if (loading || !selectedContact) return;
                  else if (e.key === "Enter") {
                    handleSaveTicket(selectedContact.id);
                  }
                }}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <React.Fragment>
                      {loading ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </React.Fragment>
                  ),
                }}
              />
            )}
          />
        </Grid>
      )
    }
    return null;
  }

  return (
    <>
      <ContactModal
        open={contactModalOpen}
        initialValues={newContact}
        onClose={handleCloseContactModal}
        onSave={handleAddNewContactTicket}
      ></ContactModal>
      <Dialog open={modalOpen} onClose={handleClose}>
        <DialogTitle id="form-dialog-title">
          {i18n.t("newTicketModal.title")}
        </DialogTitle>
        <DialogContent dividers className={classes.dialogInputs}>
          <Grid style={{ width: 300 }} container spacing={2}>
            {/* CONTATO */}
            {renderContactAutocomplete()}
            {/* FILA */}
            <Grid xs={12} item>
              <Select
                fullWidth
                displayEmpty
                variant="outlined"
                value={selectedQueue}
                onChange={(e) => {
                  setSelectedQueue(e.target.value)
                }}
                MenuProps={{
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                  },
                  getContentAnchorEl: null,
                }}
                renderValue={() => {
                  const emptyLabel = userHasQueues
                    ? i18n.t("newTicketModal.selectQueue")
                    : i18n.t("newTicketModal.noQueue")
                  if (selectedQueue === "") {
                    return emptyLabel
                  }
                  const queue = user.queues.find(q => q.id === selectedQueue)
                  return queue?.name || emptyLabel
                }}
              >
                {!userHasQueues && (
                  <MenuItem dense value="">
                    <ListItemText primary={i18n.t("newTicketModal.noQueue")} />
                  </MenuItem>
                )}
                {user.queues?.length > 0 &&
                  user.queues.map((queue, key) => (
                    <MenuItem dense key={key} value={queue.id}>
                      <ListItemText primary={queue.name} />
                    </MenuItem>
                  ))
                }
              </Select>
            </Grid>
            {/* CONEXAO — campo abre o popup em grade (ConnectionSelectDialog) */}
            <Grid xs={12} item>
              <Button
                fullWidth
                variant="outlined"
                onClick={() => setConnectionDialogOpen(true)}
                style={{ justifyContent: "flex-start", textTransform: "none", height: 56 }}
                startIcon={<WhatsApp style={{ color: "#25d366" }} />}
              >
                {(() => {
                  const whatsapp = findWhatsappById(whatsapps, selectedWhatsapp);
                  if (!whatsapp) return i18n.t("newTicketModal.selectConnection");
                  return (
                    <Typography component="span" style={{ fontSize: 14, display: "inline-flex", alignItems: "center" }}>
                      {whatsapp.name}&nbsp;
                      <span className={isConnectedStatus(whatsapp.status) ? classes.online : classes.offline}>
                        ({whatsapp.status})
                      </span>
                    </Typography>
                  );
                })()}
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            color="secondary"
            disabled={loading}
            variant="outlined"
          >
            {i18n.t("newTicketModal.buttons.cancel")}
          </Button>
          <ButtonWithSpinner
            variant="contained"
            type="button"
            disabled={!selectedContact}
            onClick={() => handleSaveTicket(selectedContact.id)}
            color="primary"
            loading={loading}
          >
            {i18n.t("newTicketModal.buttons.ok")}
          </ButtonWithSpinner>
        </DialogActions>
      </Dialog>

      {/* Popup em grade para seleção da conexão do chamado */}
      <ConnectionSelectDialog
        open={connectionDialogOpen}
        onClose={() => setConnectionDialogOpen(false)}
        whatsapps={whatsapps}
        selectedWhatsappId={selectedWhatsapp}
        onSelect={(whatsapp) => {
          if (whatsapp) setSelectedWhatsapp(whatsapp.id);
        }}
        title={i18n.t("newTicketModal.selectConnectionDialogTitle")}
      />

      {/* Dialog para mostrar ticket existente */}
      <Dialog open={openAlert} onClose={handleCloseAlert}>
        <DialogTitle>{i18n.t("newTicketModal.existingTicket.title")}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {i18n.t("newTicketModal.existingTicket.message")}
            {userTicketOpen && (
              <>
                <br />
                <strong>{i18n.t("newTicketModal.existingTicket.attendantLabel")}</strong> {userTicketOpen}
              </>
            )}
            {queueTicketOpen && (
              <>
                <br />
                <strong>{i18n.t("newTicketModal.existingTicket.queueLabel")}</strong> {queueTicketOpen}
              </>
            )}
            {existingTicket?.whatsapp?.name && (
              <>
                <br />
                <strong>{i18n.t("newTicketModal.existingTicket.connectionLabel")}</strong> {existingTicket.whatsapp.name}
              </>
            )}
            <br />
            <br />
            {existingIsGroup ? (
              <>
                {i18n.t("newTicketModal.existingTicket.groupSingleTicket")}
              </>
            ) : canForceNewTicket ? (
              <>
                {findWhatsappById(whatsapps, selectedWhatsapp)?.name
                  ? i18n.t("newTicketModal.existingTicket.canCreateNewWithConnection", {
                      connection: findWhatsappById(whatsapps, selectedWhatsapp).name,
                    })
                  : i18n.t("newTicketModal.existingTicket.canCreateNew")}
              </>
            ) : (
              <>
                {i18n.t("newTicketModal.existingTicket.sameConnection")}
              </>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseAlert} color="secondary" variant="outlined">
            {i18n.t("newTicketModal.buttons.cancel")}
          </Button>
          {canForceNewTicket && (
            <Button
              onClick={handleForceCreateTicket}
              color="secondary"
              variant="contained"
            >
              {i18n.t("newTicketModal.existingTicket.createNew")}
            </Button>
          )}
          <Button
            onClick={handleOpenExistingTicket}
            color="primary"
            variant="contained"
            autoFocus
          >
            {i18n.t("newTicketModal.existingTicket.openExisting")}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Cloud API - Template picker dialog */}
      <Dialog
        open={templatePickerOpen}
        onClose={handleCloseTemplatePicker}
        maxWidth="sm"
        fullWidth
        disableAutoFocus
        disableEnforceFocus
        disableRestoreFocus
      >
        <DialogTitle>{i18n.t("newTicketModal.templatePicker.title")}</DialogTitle>
        <DialogContent>
          <DialogContentText style={{ marginBottom: 16 }}>
            {i18n.t("newTicketModal.templatePicker.description")}
          </DialogContentText>
          {loadingTemplates ? (
            <Box display="flex" justifyContent="center" p={3}>
              <CircularProgress />
            </Box>
          ) : cloudApiTemplates.length === 0 ? (
            <DialogContentText>
              {i18n.t("newTicketModal.templatePicker.noTemplates")}
            </DialogContentText>
          ) : (
            <>
              <FormControl fullWidth variant="outlined" margin="dense">
                <InputLabel>{i18n.t("newTicketModal.templatePicker.selectTemplate")}</InputLabel>
                <Select
                  value={selectedCloudApiTemplate}
                  onChange={(e) => handleSelectCloudApiTemplate(e.target.value)}
                  label={i18n.t("newTicketModal.templatePicker.selectTemplate")}
                >
                  {cloudApiTemplates.map((t) => (
                    <MenuItem key={t.id} value={t.id}>
                      {t.displayName || t.name} ({t.language}) - {t.category}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {(() => {
                const selObj = cloudApiTemplates.find((t) => t.id === parseInt(selectedCloudApiTemplate));
                if (!selObj) return null;
                return (
                  <Box mt={2} p={2} bgcolor="background.default" border={1} borderColor="divider" borderRadius={4}>
                    <Typography variant="caption" color="textSecondary">
                      {i18n.t("newTicketModal.templatePicker.preview")}
                    </Typography>
                    <Typography variant="body2" style={{ whiteSpace: "pre-wrap" }}>
                      {selObj.bodyText || i18n.t("newTicketModal.templatePicker.emptyBody")}
                    </Typography>
                  </Box>
                );
              })()}

              {cloudApiTemplateVars.length > 0 && (
                <Box mt={2} key="template-vars">
                  <Typography variant="caption" color="textSecondary">
                    {i18n.t("newTicketModal.templatePicker.variables")}
                  </Typography>
                  {cloudApiTemplateVars.map((varItem, index) => (
                    <TextField
                      key={`var-${varItem.name}-${index}`}
                      label={`${i18n.t("newTicketModal.templatePicker.variable")} {{${varItem.name}}}`}
                      value={varItem.value}
                      onChange={(e) => {
                        const newVars = [...cloudApiTemplateVars];
                        newVars[index].value = e.target.value;
                        setCloudApiTemplateVars(newVars);
                      }}
                      fullWidth
                      variant="outlined"
                      size="small"
                      style={{ marginTop: 8 }}
                    />
                  ))}
                </Box>
              )}
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseTemplatePicker}>{i18n.t("newTicketModal.buttons.cancel")}</Button>
          <Button
            onClick={handleSendCloudApiTemplate}
            color="primary"
            variant="contained"
            disabled={!selectedCloudApiTemplate || sendingTemplate || loadingTemplates}
          >
            {sendingTemplate ? i18n.t("newTicketModal.templatePicker.sending") : i18n.t("newTicketModal.templatePicker.send")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default NewTicketModal;
